import logo from './../assets/img/logo.svg'
import sidebarHome from './../assets/img/sidebar/home.svg'
import sidebarShop from './../assets/img/sidebar/shop.svg'
import sidebarRolette from './../assets/img/sidebar/roulette.svg'
import headerSteam from './../assets/img/icons/steam-icon.svg'
import arrowWhite from './../assets/img/icons/arrow-white.svg'
import titleO from './../assets/img/title-o.svg'
import about_1 from './../assets/img/sobre-nosotros/01.png'
import about_2 from './../assets/img/sobre-nosotros/02.png'
import about_3 from './../assets/img/sobre-nosotros/03.png'
import servers_1 from './../assets/img/servidores/01.jpg'
import servers_2 from './../assets/img/servidores/02.jpg'
import servers_3 from './../assets/img/servidores/03.jpg'
import servers_4 from './../assets/img/servidores/04.jpg'
import servers_5 from './../assets/img/servidores/05.jpg'
// import servers_6 from './../assets/img/servidores/06.gif'
import servers_image_link from './../assets/img/servidores/links/01.jpg'
import news_image from './../assets/img/news/01.jpg'
import calendar from './../assets/img/icons/calendar.svg'
import question from './../assets/img/icons/question.svg'
import paypal from './../assets/img/donaciones/paypal.svg'
import bizum from './../assets/img/donaciones/bizum.svg'
import paysafe from './../assets/img/donaciones/paysafe.svg'
import donateImage from './../assets/img/donaciones/links/01.jpg'
import contactsEmail from './../assets/img/icons/email.svg'
import contactsFace from './../assets/img/icons/face.svg'
import arrowUp from './../assets/img/icons/arrow-up.svg'
import placeholder from './../assets/img/placeholder.png'
import profit from './../assets/img/icons/profit.svg'
import wallet from './../assets/img/icons/wallet.svg'
import gift from './../assets/img/icons/gift.svg'
import freeKassa from './../assets/img/free-kassa.svg'
import stripe from './../assets/img/stripe.svg'
import paypalTopUp from './../assets/img/paypal.svg'
import wepay from './../assets/img/wepay.svg'

export const useImages = () => {
    return {
        logo,
        sidebarHome,
        sidebarShop,
        sidebarRolette,
        headerSteam,
        arrowWhite,
        titleO,
        about_1,
        about_2,
        about_3,
        servers_1,
        servers_2,
        servers_3,
        servers_4,
        servers_5,
        // servers_6,
        servers_image_link,
        news_image,
        calendar,
        question,
        paypal,
        bizum,
        paysafe,
        donateImage,
        contactsEmail,
        contactsFace,
        arrowUp,
        placeholder,
        profit,
        wallet,
        gift,
        freeKassa,
        stripe,
        paypalTopUp,
        wepay
    }
}
